import { render, staticRenderFns } from "./RealmConundrum.vue?vue&type=template&id=58cf86cd"
import script from "./RealmConundrum.vue?vue&type=script&lang=js"
export * from "./RealmConundrum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports